import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import qs from 'qs'
// import moment from 'moment'

// import { Method, cloudFunctionRequest } from '../../../cloudFunction'
import { hubspotGetAcessToken, hubspotVerifyConnection, hubspotDisconnectIntegration } from '../../../actions'

import { Button, Icon } from 'antd'

const clientId = 'd90330c8-bb6d-4f75-9412-5a2070372426'

class HubspotRedirect extends Component {
  state = {
    // contactsResponse: null
    connectionOk: false
  }

  componentDidMount = () => {
    const { match: { params }, projects } = this.props

    const currentProject = projects[params.projectId]
    if (currentProject.usedIntegrations['hubspot']) {
      this.handleHubspotVerifyConnection()
    }

    // location.search = '?code=...'
    // after redirect from HubSpot, '?code=...' and '#{tabKey}' order is changed
    const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    if (queryParams.code) {
      this.handleHubspotGetAcessToken(queryParams.code)
    }
  }

  handleHubspotVerifyConnection = () => {
    const { match: { params }, user, hubspotVerifyConnection } = this.props

    hubspotVerifyConnection(params.projectId, user.idToken)
  }

  handleHubspotGetAcessToken = code => {
    const { match: { params }, user, hubspotGetAcessToken } = this.props
    const redirectUri = window.location.origin + window.location.pathname + '#integrations'

    hubspotGetAcessToken(code, redirectUri, params.projectId, user.idToken)
  }

  handleHubspotDisconnectIntegration = () => {
    const { match: { params }, hubspotDisconnectIntegration } = this.props

    hubspotDisconnectIntegration(params.projectId)
  }

  // getContacts = () => {
  //   const { match: { params }, user } = this.props
  //   cloudFunctionRequest('integrations/hubspot/getContacts', Method.POST, {
  //     projectId: params.projectId,
  //     userToken: user.idToken
  //   })
  //     .then(response => {
  //       console.log('getContacts - RESPONSE: ', response)
  //       this.setState({ contactsResponse: response.data.data })
  //     })
  //     .catch(error => {
  //       console.log('getContacts - ERROR: ', error)
  //     })
  // }

  render () {
    // const { contactsResponse } = this.state
    const { match: { params }, loading, projects } = this.props

    const currentProject = projects[params.projectId]

    const accessTokenUrlParams = {
      client_id: clientId,
      scope: 'contacts timeline',
      redirect_uri: window.location.origin + window.location.pathname + '#integrations'
    }
    const getAccessTokenUrl = `https://app.hubspot.com/oauth/authorize?${qs.stringify(accessTokenUrlParams)}`

    const isLoading =
      loading.hubspotVerifyConnection || loading.hubspotDisconnectIntegration || loading.hubspotGetAcessToken

    return (
      <div>
        <span style={{ fontSize: 18, marginRight: 15 }}>HubSpot</span>

        {isLoading
          ? <Icon type='loading' style={{ fontSize: 20 }} />
          : currentProject.usedIntegrations['hubspot']
              ? <span>
                <Icon type='check-circle' style={{ fontSize: 20, color: '#A8CD1B', marginRight: 15 }} />
                <Button size='small' type='danger' onClick={() => this.handleHubspotDisconnectIntegration()}>
                    disconnect
                  </Button>
              </span>
              : <span>
                <Icon type='exclamation-circle' style={{ fontSize: 20, color: '#d9321f', marginRight: 15 }} />
                <Button size='small' href={getAccessTokenUrl}>connect</Button>
              </span>}

        {/* <Button onClick={() => this.getContacts()}>getContacts</Button> */}
        {/* {contactsResponse &&
          <div>
            <h2>getContacts()</h2>
            <ul>
              {contactsResponse.map((contact, index) => {
                return (
                  <li key={index}>
                    <a href={contact['profile-url']} target='_blank'>
                      {['firstname', 'lastname', 'company', 'email'].map(prop => contact.properties[prop].value + ' ')}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>} */}

      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  loading: state.loading,
  user: state.user,
  projects: state.projects
})

const mapDispatchToProps = {
  hubspotGetAcessToken,
  hubspotVerifyConnection,
  hubspotDisconnectIntegration
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HubspotRedirect))



// WEBPACK FOOTER //
// ./src/components/ProjectSettings/Integrations/Hubspot.js